import { createAction, props } from '@ngrx/store';
import { ApplicationTypeStatusBase } from '@intellio/shared/models';

export enum ApplicationStatusesActionTypes {
  GetApplicationStatuses = '[Application Statuses] Get',
  GetApplicationStatusesSuccess = '[Application Statuses] Get Success',
  GetApplicationStatusesFailure = '[Application Statuses] Get Failure',
}

export const getApplicationStatuses = createAction(
  ApplicationStatusesActionTypes.GetApplicationStatuses,
  props<{ typeId: string }>()
);

export const getApplicationStatusesSuccess = createAction(
  ApplicationStatusesActionTypes.GetApplicationStatusesSuccess,
  props<{ typeId: string; statuses: ApplicationTypeStatusBase[] }>()
);

export const getApplicationStatusesFailure = createAction(
  ApplicationStatusesActionTypes.GetApplicationStatusesFailure,
  props<{ typeId: string; error: any }>()
);

